<template lang="pug">
  div
    .dashboard-module__title
      div
        i.iconfont.icon-woderenwu(
          :style="{color: '#3370d2', fontSize: '20px'}"
        )
        span {{ taskType === 0 ? $t('我的任务') : $t('抄送我的任务') }}
        span.task_count_container
          span.task_count {{ data.total_count }}

      .task-table_type
        div(
          v-if="data.main.count !== 0"
          @click="changeTableType(0)"
          :class="{'active': tableType === 0}"
        )
          span {{ $t('营销采购项目') }}
          span.task_count_container
            span.task_count {{ data.main.count }}
        div(
          v-if="data.ec.count !== 0"
          @click="changeTableType(1)"
          :class="{'active': tableType === 1}"
        )
          span {{ $t('媒体投放项目') }}
          span(style="margin-left: 12px").task_count_container
            span.task_count {{ data.ec.count }}
        div(
          v-if="data.star.count !== 0"
          @click="changeTableType(2)"
          :class="{'active': tableType === 2}"
        )
          span {{ $t('明星合作项目') }}
          span.task_count_container
            span.task_count {{ data.star.count }}
    el-card
      .campaign-dashboard__taskCard__title
        el-table.task-table(
          :header-row-style="{background: '#3370d2',height: '48px'}"
          :data="tasks"
          max-height="280"
          :key="taskType"
        )
          el-table-column(
            :label="$t('任务')"
            width="340"
            show-overflow-tooltip
          )
            template(slot-scope="scope")
              span.task-table__link( @click="viewTask(scope.row)" ) {{ $t(scope.row.task_name) }}
          el-table-column(
            :label="$t('项目ID')"
            prop="campaign_id"
          )
          el-table-column(
            :label="$t('项目')"
            prop="campaign_name"
            show-overflow-tooltip
          )
          el-table-column(
            :label="$t('Sub SOW')"
            prop="sub_final_scope_name"
            show-overflow-tooltip
          )
            template(slot-scope="scope")
              span {{ scope.row.sub_final_scope_name || '—' }}

          el-table-column(
            width="175"
            :label="$t('接收日期')"
          )
            template(slot-scope="scope")
              span {{ scope.row.start_date | dateFormatter }}

          //- el-table-column(
          //-   v-if="tableType === 1"
          //-   width="175"
          //-   :label="$t('截止时间')"
          //- )
          //-   template(slot-scope="scope")
          //-     span {{ scope.row.end_date | dateFormatter }}
          infinite-loading(
            :identifier="infiniteId"
            slot="append"
            @infinite="getTasks"
            force-use-infinite-wrapper=".el-table__body-wrapper"
          )
</template>

<script>
import { dateFormatter } from '@/umcc/util'
import axios from 'axios'

export default {
  props: {
    taskType: {
      type: Number,
      default () {
        return 0
      }
    }
  },
  data () {
    return {
      page: 1,
      data: {
        main: {
          count: 0,
          tasks: []
        },
        ec: {
          count: 0,
          tasks: []
        },
        star: {
          count: 0,
          tasks: []
        }
      },
      tableType: 0, // 0: main, 1: ec, 2:star
      tasks: [],
      infiniteId: new Date()
    }
  },
  filters: {
    dateFormatter
  },
  computed: {

  },
  methods: {
    getTasks ($state) {
      const url = this.taskType === 0 ? '/dashboard/getTasksAssignToMe' : '/dashboard/getTasksCopyToMe'
      axios.get(url, {
        params: {
          page: this.page,
          size: 10
        }
      }).then(data => {
        this.data = data
        if (this.page === 1 && data.main.count === 0 && data.ec.count === 0 && data.star.count === 0) {
          this.$emit('shouldhideTaskTable', false, this.taskType)
        }
        if (data.main.count === 0 && data.ec.count !== 0) {
          this.tableType = 1
        }
        if (data.main.count === 0 && data.ec.count === 0 && data.star.count !== 0) {
          this.tableType = 2
        }
        if (this.tableType === 0 && data.main.tasks.length) {
          this.page += 1
          this.tasks.push(...data.main.tasks)
          $state.loaded()
        } else if (this.tableType === 1 && data.ec.tasks.length) {
          this.page += 1
          this.tasks.push(...data.ec.tasks)
          $state.loaded()
        } else if (this.tableType === 2 && data.star.tasks.length) {
          this.page += 1
          this.tasks.push(...data.star.tasks)
          $state.loaded()
        } else {
          $state.complete()
        }
      })
    },
    changeTableType (type) {
      this.tableType = type
      // init infinite loading
      this.tasks = []
      this.page = 1
      this.infiniteId += 1
    },
    viewTask (row) {
      if (this.tableType === 2) {
        // 全明星项目
        this.$store.commit('unistar/setCampaignInfo', row)
        if (row.phase !== 'StarExecution') {
          row.type = this.$t('明星合作项目')
        }
        this.$store.commit('unistar/setSOWInfo', row)
        this.$store.dispatch('unistar/getProcessTasks', {
          business_key: row.phase === 'StarExecution' ? row.sub_final_scope_id : row.campaign_id,
          business_type: row.business_type,
          phase_type: row.phase === 'StarExecution' ? 2 : 1
        }).then(res => {
          this.$router.push({
            path: '/unistar/flow/' + row.action
          })
        })
      } else {
        this.$store.commit('campaign/setCampaignVersion', row.version)
        this.$store.commit('campaign/setId', row.campaign_id)
        this.$store.commit('campaign/setTaskId', row.taskId)
        this.$store.commit('campaign/setTaskName', row.task_name)
        this.$store.commit('campaign/setCampaignName', row.campaign_name)
        this.$store.commit('campaign/setSubFinalScopeId', row.sub_final_scope_id)
        this.$store.commit('campaign/setBusinessType', row.business_type)
        this.$store.commit('campaign/setOriginalBusinessType', row.business_type)
        this.$store.commit('campaign/setBusinessKey', row.business_key)
        this.$store.commit('campaign/setPhaseType', row.phase_type)
        this.$store.commit('campaign/setDotPhaseType', row.dot_phase_type)
        this.$store.commit('campaign/setDotBusinessType', row.dot_business_type)
        this.$store.commit('campaign/setDotSubFinalScopeId', row.sub_final_scope_id)
        if (row.campaign_type != null && row.campaign_type === 1) {
          this.getSubFinalScopeInfo(row.sub_final_scope_id)
          this.$router.push({
            path: '/shortcut/' + row.action
          })
        } else if (row.campaign_type != null && row.campaign_type === 2) {
          this.viewECCampaign(row)
        } else {
          let action = row.action
          if (row.version && row.version > 'v2') {
            action += '-' + row.version
          }
          this.$router.push({
            path: '/campaign/' + action,
            query: {
              status: row.status
            }
          })
        }
      }
    },
    async getSubFinalScopeInfo (id) {
      try {
        this.subFinalScopeInfo = await axios.get('/management/subfinalExpress/getSubFinalScope', {
          params: {
            sub_final_scope_id: id
          }
        })
        this.$store.commit('campaign/setSubFinalScopeInfo', this.subFinalScopeInfo)
      } catch (err) {
        throw new Error(err)
      }
    },
    viewECCampaign (row) {
      this.loading = true
      this.$store.commit('campaign/setId', row.campaign_id)
      axios.get('/management/ec/getTabList', {
        params: {
          sub_final_scope_id: row.sub_final_scope_id
        }
      })
        .then(res => {
          this.loading = false
          const arr = res.filter(i => i.can_view)
          arr.push({
            tab_name: 'tab_user',
            action: '/ec-campaign/process/campaign-participant',
            version: 'v1'
          })
          this.$store.commit('campaign/setECTab', arr)
          const version = row.version != null ? row.version : 'v1'
          this.$router.push({
            path: row.action + '-' + version
          })
        })
        .catch(err => {
          this.loading = false
          throw new Error(err)
        })
    }
  }
}
</script>

<style lang="stylus">
.task-table
  .el-table__header
    th
      background none
    .cell
      color #ffffff
      padding 0 22px
      font-size 16px
      font-weight 400
  .el-table__body
    .task-table__link
      color $main
      cursor pointer
    td
      border none
      height 44px
    .cell
      padding 0 22px
      font-size 14px

  .el-table--enable-row-hover .el-table__body tr:hover > td:nth-child(1)::before
    content: '';
    height: 100%;
    width: 3px;
    background-color: #4896e6;
    left: 0;
    top: 1px;
    position: absolute
</style>
